import type { ExtensionType } from '@blocksuite/store';

import { MentionInlineSpecExtension } from './inline-spec';

export const inlineMentionExtensions: ExtensionType[] = [
  MentionInlineSpecExtension,
];
